import { render } from "./TraineeRevokeSignOffModal.vue?vue&type=template&id=6b271f28&scoped=true"
import script from "./TraineeRevokeSignOffModal.vue?vue&type=script&lang=js"
export * from "./TraineeRevokeSignOffModal.vue?vue&type=script&lang=js"

import "./TraineeRevokeSignOffModal.vue?vue&type=style&index=0&id=6b271f28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b271f28"]])

export default __exports__